export const view = {
  methods: {
    view(id, name) {
      this.$router.push({ name: name, params: { id: id } });
    },
  },
};
